var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Sorry! You need to setup a supplier account to purchase this product. Please contact "),_c('b',[_vm._v(_vm._s(_vm.cNumber))]),_vm._v(" or "),_c('a',{attrs:{"href":'mailto:' + _vm.cEmail}},[_vm._v(" "+_vm._s(_vm.cEmail))])])
}
var staticRenderFns = []

export { render, staticRenderFns }